export const PRIMARY = '#2DC1D0';
export const SECONDARY = '#453E97';
export const SECONDARY_LIGHT = '#EFF4FA';
export const TEXT = '#505050';
export const BACKGROUND_FOOTER = '#1E1E1E';
export const TEXT_FOOTER = '#495057';
export const LINKS_FOOTER = '#ADB5BD';
